import React from 'react';
import { Card, Typography } from 'antd';
import { SettingsCardProps } from './types';

const { Title } = Typography;

const SettingsCard: React.FC<SettingsCardProps> = ({ title, children }) => (
    <Card size="small" className="settings-card">
        <Title level={5} className="settings-title">{title}</Title>
        {children}
    </Card>
);

export default SettingsCard;